module.exports = __webpack_public_path__ + "static/img/buddy_pictgrid39_980x804.1c2ae54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/buddy_pictgrid39_980x804.jpg
// module id = B3cu
// module chunks = 0